import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../services/main/api.service';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Router, ActivatedRoute } from '@angular/router';
import { Global } from '../../../services/global';
import { BaseCrudComponent } from '../../base-crud/base-crud.component';
import { TranslateService } from '@ngx-translate/core';
import { Observable, BehaviorSubject, of, throwError, from } from 'rxjs';
import { mergeMap, catchError, timeout, retry } from 'rxjs/operators';
import { ExportAsService, ExportAsConfig } from 'ngx-export-as';
import * as moment from 'moment-timezone';

import { LazyLoadEvent } from 'primeng/api';
import { SelectItem } from 'primeng/api';
import { MessageService } from 'primeng/api';

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

@Component({
  selector: 'app-customerscollectors',
  templateUrl: './customerscollectors.component.html',
  styleUrls: ['./customerscollectors.component.css']
})
export class CustomersCollectorsComponent extends BaseCrudComponent {

  translations: any;
  header: any;
  momentjs: any = moment;
  curr_date: any;
  dstart: any;
  dend: any;
  zones: any;
  theaders: any;

  offline_key_list = 'SALES_COLLECTORS';
  offline_date = '';
  zoom = 15;
  track_lat: any;//number = -2.191332;
  track_lng: any;//number = -79.565221;
  lat: number = -2.191332;
  lng: number = -79.565221;

  latCustomer: number = -2.191332;
  lngCustomer: number = -79.565221;

  notif_refresh_time = 12000;
  notiftimer: any;
  is_sendingpos = false;
  is_sendingmail = false;


  currentLocation: string;

  constructor(
    srv: ApiService,
    modalService: NgbModal,
    storage: Storage,
    router: Router,
    private route: ActivatedRoute,
    public translate: TranslateService
  ) {
    super(srv, modalService, storage, router);
    this.read_url = 'Location/All';
    this.update_url = 'Location/Save';
    this.header = {};
    this.zones = [];

    this.srv.offline.subscribe(r => {
      this.isOffline = r;
    });

    //this.isOffline = false;

    this.theaders = [
      { field: 'clientCode', header: 'Código', sortable: true, sortfield: 'clientCode', styleC: { 'text-align': 'center' }, width: { 'width.px': 140 }, isColor: false, pre: '', pos: '', total: '', filter: 'input' },
      { field: 'clientName', header: 'Nombre', sortable: true, sortfield: 'clientName', styleC: { 'text-align': 'center' }, width: { 'width.px': 180 }, isColor: false, pre: '', pos: '', total: '', filter: 'input' },
      { field: 'recipientCode', header: 'Cod. Sucursal', sortable: true, sortfield: 'recipientCode', styleC: { 'text-align': 'center' }, width: { 'width.px': 140 }, isColor: false, pre: '', pos: '', total: '', filter: 'input' },
      { field: 'recipientName', header: 'Sucursal', sortable: true, sortfield: 'recipientName', styleC: { 'text-align': 'center' }, width: { 'width.px': 180 }, isColor: false, pre: '', pos: '', total: '', filter: 'input' },
      { field: 'city', header: 'Ciudad', sortable: true, sortfield: 'city', styleC: { 'text-align': 'center' }, width: { 'width.px': 140 }, isColor: false, pre: '', pos: '', total: '', filter: 'input' },
      { field: 'location', header: 'Ubicación', sortable: false, sortfield: 'location', styleC: { 'text-align': 'center' }, width: { 'width.px': 140 }, isColor: false, pre: '', pos: '', total: '' }
    ];
  }

  ngOnInit() {
    this.curr_date = this.momentjs().tz('America/Guayaquil').format('YYYY-MM-DD');

    // this.trackMe();
    this.subscribeCurrentPosition();

    this.translate.getTranslation(this.translate.currentLang)
      .subscribe((translations) => {
        this.translations = translations;
        super.ngOnInit();
        this.getList();
      });
  }

  public getList() {
    var qst = this.read_url;
    var obj: any;
    this.rows = [];

    if (this.isOffline) {
      this.srv.getOfflineData(this.offline_key_list).then(x => {
        //console.log(x);
        var rs = x.data;
        if ((rs != null) && (rs != undefined)) {
          this.parseDetails(rs);
          this.offline_date = x.last_update;
        }
      });
    }
    else {
      this.loadingList = true;
      this.srv.getCall(qst).subscribe(x => {
        this.loadingList = false;

        if (x.status) {
          var rs = x.data;
          this.srv.saveOfflineData(this.offline_key_list, rs);
          this.parseDetails(rs);
        }
      });
    }

  }

  parseDetails(rs: any) {
    this.rows = [];
    this.rawdata = [];
    var tmp: any;
    var tobj: any;
    let coords: any;
    this.rawdata = rs;
    this.rows = this.rawdata;
  }


  trackMe() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.track_lat = position.coords.latitude;
        this.track_lng = position.coords.longitude;
      });

      navigator.geolocation.watchPosition((position) => {
        this.track_lat = position.coords.latitude;
        this.track_lng = position.coords.longitude;
      });

    } else {
      alert("Geolocation is not supported by this browser.");
    }
  }


  subscribeCurrentPosition() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.track_lat = position.coords.latitude;
          this.track_lng = position.coords.longitude;
          console.log('success get');
          // console.log(this.track_lat+';'+this.track_lng);
          // this.userService.sendCurrentPosition(this.myLocation, this.supplierId);  //send position to backend
          // setTimeout(() => this.subscribeCurrentPosition(), 3000);
        }
        , (error) => {
          console.log('error get' + error.message);
          //LoggingService.error('Geolocation error: '+ error);
        },
        {
          // enableHighAccuracy:true,
          timeout: 2000,
          maximumAge: 0
        }
      );


      navigator.geolocation.watchPosition(
        (position) => {
          this.track_lat = position.coords.latitude;
          this.track_lng = position.coords.longitude;
          console.log('success watch');
        }
        , (error) => {
          console.log('error watch: ' + error.message);
          //LoggingService.error('Geolocation error: '+ error);
        },
        {
          // enableHighAccuracy:true,
          timeout: 2000,
          maximumAge: 0
        }
      );
    } else {
      console.log('Geolocation not supported in this browser');
    }
  }


  sendToGmapsDirections(content: any) {

    let coords: any;
    coords = content.split(';');
    this.latCustomer = parseFloat(coords[0]);
    this.lngCustomer = parseFloat(coords[1]);

    if( (this.track_lng === undefined) || (this.track_lat === undefined) ){
      alert('Sin lectura de GPS');
      return;
    }
      window.open('https://www.google.com/maps/dir/?api=1&origin=' + this.track_lat + ',' + this.track_lng + '&destination=' + this.latCustomer + ',' + this.lngCustomer + '&travelmode=driving', '_blank');
   
  }

}
